module.exports = __webpack_public_path__ + "img/report.19b9e77c.jpg";